import { fromPairs } from 'lodash';
import { Empty, Loaded } from 'stores/core';
import { AccountPermissionSetType, ProjectPermissionSetType } from './permission-set';
const KEYS = Object.values(ProjectPermissionSetType).filter((x)=>typeof x === 'number').map((x)=>x).concat(...Object.values(AccountPermissionSetType).filter((x)=>typeof x === 'number').map((x)=>x));
const EMPTY = {
    byKey: fromPairs(KEYS.map((x)=>[
            x,
            Empty()
        ]))
};
const put = (set)=>({ byKey })=>({
            byKey: {
                ...byKey,
                [set.permissionSetType]: Loaded(set)
            }
        });
const putAll = (sets)=>(store)=>sets.reduce((prev, set)=>put(set)(prev), store);
export const PermissionSetsStore = {
    empty: ()=>EMPTY,
    putAll
};
